import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Flame, Inbox, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { getTheme } from "@/lib/themes";
import { Button } from "@/components/ui/button";

export default function PublicProfile() {
  const { handle } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const clean = (handle || "").replace(/^@/, "");

  useEffect(() => {
    api.get(`/public/${clean}`).then(({ data }) => setData(data)).catch(() => setError(true));
  }, [clean]);

  const theme = getTheme(data?.theme);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#c19a6b] gap-4">
        <p className="font-hand text-4xl text-[#3a2f22]">This board is private or doesn't exist.</p>
        <Button onClick={() => navigate("/")} className="rounded-full bg-[#2b2620] text-[#fdf6e3] font-display font-bold">Go home</Button>
      </div>
    );
  }
  if (!data) return <div className="min-h-screen bg-[#c19a6b]" />;

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ backgroundImage: theme.board, backgroundColor: theme.swatch, backgroundSize: "cover", backgroundPosition: "center" }}>
      <div className="bg-white p-4 pb-6 paper-shadow-lift rotate-[-1.5deg] max-w-sm w-full">
        <span className="thumbtack" />
        <div className="w-full aspect-square bg-[#efeae2] overflow-hidden flex items-center justify-center">
          {data.avatar_url ? <img src={`${api.defaults.baseURL}/files/${data.avatar_url}`} alt="" className="w-full h-full object-cover" /> : <span className="font-display font-black text-6xl text-[#c9b48f]">{data.name?.[0]}</span>}
        </div>
        <p className="font-hand text-3xl text-center text-[#3a2f22] mt-3">{data.name}</p>
        <p className="text-center font-note text-[#6b6155]">@{data.handle}</p>
        <p className="text-center text-sm text-[#4a4238] mt-3 font-note">{data.about_note}</p>
        <div className="grid grid-cols-3 gap-2 mt-5">
          <div className="text-center"><Inbox className="w-5 h-5 mx-auto text-[#007aff]" /><p className="font-display font-black text-xl">{data.received}</p><p className="tag-label text-[#a0703c]">Got</p></div>
          <div className="text-center"><CheckCircle2 className="w-5 h-5 mx-auto text-[#34c759]" /><p className="font-display font-black text-xl">{data.completed}</p><p className="tag-label text-[#a0703c]">Done</p></div>
          <div className="text-center"><Flame className="w-5 h-5 mx-auto text-[#ff3b30]" /><p className="font-display font-black text-xl">{data.streak_days}</p><p className="tag-label text-[#a0703c]">Streak</p></div>
        </div>
        <Button onClick={() => navigate("/")} className="w-full mt-5 rounded-full bg-[#ff3b30] hover:bg-[#e0271d] text-white font-display font-bold">Make your own board</Button>
      </div>
    </div>
  );
}
